import React, { useEffect, useState } from 'react';
import SearchRow from 'components/SearchRow/SearchRow';
import { get } from 'lib/comms';
import Table from 'components/Table/Table';
import HomeHubItemPage from './HomeHubItemPage';
import moment from 'moment';
import { Navigate } from 'react-router-dom';
import { type } from 'lib/homeHub';

const HomeHubPage = (props) => {
    const [state, setState] = useState({
        data: [],
        search: '',
        activeTab: null,
        editing: null,
        stepIndex: 0,
    });

    const columns = [
        {
            name: 'Title',
            selector: (row) => row.title,
            sortable: true,
            grow: 3,
            wrap: true,
        },
        {
            name: 'Subtitle',
            selector: (row) => row.subtitle,
            sortable: true,
            grow: 3,
            wrap: true,
        },
        {
            name: 'Type',
            selector: (row) => type.find((item) => item.id === row.type).name,
            sortable: true,
            grow: 3,
            wrap: true,
        },
        {
            name: 'Order',
            selector: (row) => row.order,
            sortable: true,
            grow: 3,
            wrap: true,
        },
        {
            name: 'Created At',
            selector: (row) => row.created_at,
            sortable: true,
            format: (row) => (row.created_at ? moment(row.created_at).format('DD MMM YYYY') : ''),
        },
    ];

    const updateItemCreated = () => {
        setState({ ...state, createdNew: true });
    };

    const doneEditing = () => {
        setState({ ...state, editing: null });
    };

    const reload = async (type) => {
        let resp = await get('cms/home_hub', null, true);
        if (resp && resp.status === 401) setState({ ...state, logout: true });
        if (resp && resp.homeHubItems) {
            if (type === 'back') {
                setState({ ...state, data: resp.homeHubItems, editing: null });
            } else {
                setState({ ...state, data: resp.homeHubItems });
            }
        } else console.log(resp);
    };

    useEffect(() => {
        reload();
    }, [setState]);

    if (state.logout) return <Navigate to={{ pathname: '/logout', state: { from: props.location } }} />;

    let { data, search, editing } = state;
    if (search) {
        data = data.filter((item) => `${item.title}${item.location}`.toLowerCase().indexOf(search.toLowerCase()) >= 0);
    }

    return (
        <>
            {state.editing ? (
                <HomeHubItemPage
                    homeHub={editing}
                    onBack={doneEditing}
                    updateItemCreated={updateItemCreated}
                    activeTab={state.activeTab}
                    reload={reload}
                />
            ) : (
                <div className="maincontainer">
                    <h4>Home Hub</h4>
                    <SearchRow
                        value={search}
                        searchTitle="Search by title of home hub item"
                        onSearch={(search) => setState({ ...state, search })}
                        buttonTitle="ADD NEW HOME HUB ITEM"
                        onBtnClick={(item) => setState({ ...state, editing: { id: 'new' } })}
                    />
                    <Table
                        columns={columns}
                        data={data}
                        onRowClicked={(item) => setState({ ...state, editing: item, activeTab: null })}
                        tableID="homeHub"
                        defaultSortField={columns[1].selector}
                    />
                </div>
            )}
        </>
    );
};

export default HomeHubPage;
